define(function() {
    /**
     * @ignore
     * Overrides default Leaflet touch device recognition.
     * Leaflet uses Object.freeze on L.Browser, so we are unable to override L.Browser.touch.
     * Luckly Leaflet provides global flag that let's us change the default detection
     * by setting global variable: https://github.com/Leaflet/Leaflet/blob/master/build/docs-misc.leafdoc.
     */
    window.L_NO_TOUCH = !('ontouchstart' in window ||
        window.DocumentTouch && document instanceof window.DocumentTouch);
});



// WEBPACK FOOTER //
// ./globals.js